import script from "./ApplicationAgentView.vue?vue&type=script&setup=true&lang=js"
export * from "./ApplicationAgentView.vue?vue&type=script&setup=true&lang=js"

import "./ApplicationAgentView.vue?vue&type=style&index=0&id=a70fa436&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a70fa436"]])

export default __exports__